import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities, deleteEntity } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/blockout/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/blockout/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/blockout/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/blockout/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/blockout/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/blockout/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/blockout/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/blockout/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/blockout/UPDATE_FAILURE'

const DELETE_REQUEST = 'contenthouse/blockout/DELETE_REQUEST'
const DELETE_SUCCESS = 'contenthouse/blockout/DELETE_SUCCESS'
const DELETE_FAILURE = 'contenthouse/blockout/DELETE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  result: {},
  deleting: false,
  errors: [],
  loaded: false,
  loading: false,
  updating: false,
}

// Actions
export function fetchRequest(){
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function deleteRequest(){
  return {
    type: DELETE_REQUEST,
  }
}

export function deleteSuccess(){
  return {
    type: DELETE_SUCCESS,
  }
}

export function deleteFailure(errors = []){
  return {
    type: DELETE_FAILURE,
    errors,
  }
}

// Action Creators
export function loadBlockouts(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v3/blockouts', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data.results, Schemas.BLOCKOUT_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function loadCurrentBlockouts(options){
  return (dispatch) => {
    dispatch(fetchRequest())

    const promise = api('/v3/users/current/blockouts', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data.results, Schemas.BLOCKOUT_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(data))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function createBlockout(blockout, options = {}){
  const config = {
    method: 'POST',
    data: blockout,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api(`/v3/blockouts/${blockout.user.replace('User/', '')}`, options, config)
      .then((data) => {
        const normalizedJson = normalize(data.data, Schemas.BLOCKOUT)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data: data.data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function createCurrentBlockout(blockout, options = {}){
  const config = {
    method: 'POST',
    data: blockout,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/v3/users/current/blockouts', options, config)
      .then((data) => {
        const normalizedJson = normalize(data.data, Schemas.BLOCKOUT)
        dispatch(updateEntities(normalizedJson))
        dispatch(createSuccess())

        return { success: true, data: data.data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function validateCurrentBlockout(blockout, options = {}){
  const config = {
    method: 'POST',
    data: blockout,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api('/v3/users/current/blockouts/validate', options, config)
      .then((data) => {
        dispatch(createSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateBlockout(blockout, options = {}){
  const config = {
    method: 'PUT',
    data: blockout,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v3/blockouts/${blockout.id}`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.BLOCKOUT)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function updateCurrentBlockout(blockout, options = {}){
  const config = {
    method: 'PUT',
    data: blockout,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v3/users/current/blockouts/${blockout.id}`, options, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.BLOCKOUT)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())
        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function deleteBlockout(blockout){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/v3/blockouts/${blockout.id}`, { permanent: true }, config)
      .then(({ data }) => {
        const normalizedJson = normalize(blockout, Schemas.BLOCKOUT)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, result: data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, result: errors }
      })
    return promise
  }
}

export function deleteCurrentBlockout(blockout){
  const config = {
    method: 'DELETE',
  }

  return (dispatch) => {
    dispatch(deleteRequest())

    const promise = api(`/v3/users/current/blockouts/${blockout.id}`, { permanent: true }, config)
      .then(({ data }) => {
        const normalizedJson = normalize(blockout, Schemas.BLOCKOUT)
        dispatch(deleteEntity(normalizedJson))
        dispatch(deleteSuccess())

        return { success: true, result: data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(deleteFailure(errors))

        return { success: false, result: errors }
      })
    return promise
  }
}

// Reducer
export default function reducer(state = initialState, action = {}){
  const { type, payload, errors } = action

  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
        result: payload.continuationToken,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    case DELETE_REQUEST:
      return {
        ...state,
        deleting: true,
      }
    case DELETE_SUCCESS:
      return {
        ...state,
        deleting: false,
        errors: [],
      }
    case DELETE_FAILURE:
      return {
        ...state,
        deleting: false,
        errors,
      }
    default:
      return state
  }
}
